import {SystemAlertsService} from "../service/SystemAlertsService";
import {ClientEventService} from "../../../../services/client-events/ClientEventService";
import {BehaviorSubject, Observable, Scheduler} from "rxjs";
import {orderAlerts, SystemAlert, SystemAlerts} from "../model/SystemAlert";

const BackgroundUpdateDelayMinutes = 5;
const BackgroundUpdateDelaySeconds = BackgroundUpdateDelayMinutes * 60;
const BackgroundUpdateDelayMillis = BackgroundUpdateDelaySeconds * 1000;

export class SystemAlertStore {

    public static readonly id = "systemAlertStore";

    private readonly alert: Observable<SystemAlert | null>;

    /** @ngInject */
    public constructor(private readonly systemAlertService: SystemAlertsService,
                       private readonly clientEventService: ClientEventService) {
        this.alert = this.buildAlert();
    }

    private buildAlert(): Observable<SystemAlert | null> {
        const updated = new BehaviorSubject(true);
        const backgroundCheck = updated.debounceTime(BackgroundUpdateDelayMillis);
        const updateFromEvent = this.clientEventService
                                    .events()
                                    .filter((event) => false) // TODO Fix once we have a client event for this
                                    .map(() => true);

        const source = Observable.merge(backgroundCheck, updateFromEvent);

        return source.startWith(true)
                     .auditTime(1000)
                     .switchMap(() => this.systemAlertService.current())
                     .map((alerts) => this.calculateCurrentAlert(alerts))
                     .do(() => updated.next(true))
                     .publishReplay(1)
                     .refCount();
    }

    private calculateCurrentAlert(alerts: SystemAlerts): SystemAlert | null {
        if (alerts.length === 0) {
            return null;
        }
        const sorted = [...alerts].sort(orderAlerts());
        return sorted[0];
    }

    public get current(): Observable<SystemAlert | null> {
        return this.alert.observeOn(Scheduler.async);
    }
}
